//export const BASE_URL = "http://3.7.194.167:5006/api/v1"
// export const BASE_URL = "http://localhost:5000/api/v1"
export const BASE_URL = "https://api.pranainsight.in/api/v1/"
// export const BASE_URL = "http://3.7.111.97:5000/api/v1/"